// lodash
import _forEach from 'lodash/forEach';
import _find from 'lodash/find';
import _reduce from 'lodash/reduce';
import _toFinite from 'lodash/toFinite';
import _sortBy from 'lodash/sortBy';
import _concat from 'lodash/concat';
import _filter from 'lodash/filter';

import Shop from '@/shop';

/** @private */
var MIN_QUANTITY = 0;

/**
 * TODO: Вынести все magic numbers и константы, в отдельный модуль.
 * TODO: Разобраться, где и как используется сам класс, чтобы избежать утечек
 * внутренних данных
 */
/**
 * @private
 * @memberof Product
 *
 * @description
 * Подготовка типов цен
 *
 * Логика применения типов цен.
 * 1) За основу берется цена в поле price - базовая цена.
 * 2) Пользователь состоит в группе?
 *  а) нет. Цены применяются как есть.
 *  б) да. Цена для группы указывается как базовая цена. Делаем фильтрацию цен
 *     от кол-ва так, что ни одна из них не должна быть больше базовой цены.
 * 3) Если у товара есть цены от кол-ва, они применяются при достижении
 *  указанного кол-ва
 *
 * @param {Array} price_kinds - массив с условиями применения типов цен,
 * зависящих от кол-ва
 * @param {Array} variants - массив с описанием вараинтов товара
 *
 * @return {Object} self - возвращает собранный экземпляр.
 */
var PriceKinds = function(price_kinds, variants) {
  var self = this;

  self.price_rules = price_kinds;
  self.price_kinds = self._buildPriceKinds(variants);

  return self;
};

/**
 * @private
 *
 * @description
 * Строим правильный массив цен.
 *
 * @param {Object} variants - объект с входными данными о Вариантах товара.
 *
 * @return {Object} - Объект с разобранными типами цен
 */
PriceKinds.prototype._buildPriceKinds = function(variants) {
  var self = this;
  var _clientGroup = Shop.config.get('client_group').client_group;
  var _price_kinds = {};

  _forEach(variants, function(variant) {
    var _base_price = [ self._getPriceType(MIN_QUANTITY, variant.price) ];

    _price_kinds[variant.id] = _sortBy(_concat(_base_price, self._getVariantPrices(variant)), 'min_quantity');

  });

  if (_clientGroup) {
    _price_kinds = self._getFilterredPrices(_price_kinds);
  }

  return _price_kinds;
};

/**
 * @private
 *
 * @description
 * Получение типов цен. Метод нужен, чтобы не светить внутреннюю кухню Класса.
 *
 * @return {Object} - объект с типами цен.
 */
PriceKinds.prototype.getPriceKinds = function() {
  var self = this;

  return self.price_kinds;
};

/**
 * @private
 *
 * @description
 * Проверяем, применяется ли данная цена по кол-ву. Определяем по price_index.
 * В price_rules указаны со смещением в +1.
 *
 * @param {Number} price_index - индекс типа цен.
 *
 * @return {(Number|False)} - кол-во при котором срабатывает цена. `False`, если
 * цена с указанным индексом отсутствует в правилах.
 */
PriceKinds.prototype._priceKindQuantity = function(price_index) {
  var self = this;
  var _quantity = null;
  var _value = false;

  _quantity = _find(self.price_rules, { price_index: price_index + 1 });
  if (_quantity) {
    _value = _quantity.value;
  }

  return _value;
};

/**
 * @description
 * Разбираем цены варианта, вытаскивая только типы цен, зависящие от кол-ва
 *
 * @param {Object} variant - oбъект с информацией о варианте
 *
 * @return {Array} - массив цен.
 */
PriceKinds.prototype._getVariantPrices = function(variant) {
  var self = this;
  var prices = [];

  prices = _reduce(variant.prices, function(_prices, _price, _index) {
    var _quantity = self._priceKindQuantity(_index);

    if (_price && _quantity) {
      _prices.push(self._getPriceType(_quantity, variant.prices[_index]));
    }

    return _prices;
  }, []);

  return prices;
};

/**
 * @description
 * Получаем отфильтрованные цены вариантов. Цены по кол-ву не должны привышать
 * базовую цену варианта.
 *
 * @param {Object} price_kinds - Исходный объект с ценами вариантов.
 *
 * @return {Object} - отфильтрованные цены для товара.
 */
PriceKinds.prototype._getFilterredPrices = function(price_kinds) {
  var _price_kindes = {};

  _price_kindes = _reduce(price_kinds, function(result, prices, variant_id) {
    var _base_price = prices[0].price;
    var _prices = _filter(prices, function(_priceType) {
      return _priceType.price <= _base_price;
    });

    result[variant_id] = _prices;

    return result;
  }, {});

  return _price_kindes;
};

/**
 * @description
 * Собирает и конвертирует объект типа цен.
 *
 * @param {Number} quantity - минимальное кол-во, при котором применяется цена
 * @param {Number} price - цена. Конвертируется в дробное.
 *
 * @return {Object} - объект, описывающий применение цены.
 */
PriceKinds.prototype._getPriceType = function(quantity, price) {
  var _price_type = {
    min_quantity: quantity,
    price: _toFinite(price)
  };

  return _price_type;
};

export default PriceKinds;
